@import '../../../scss/global_v2_member_light-vars.css';

.tab-group {
  width: 100%;
}

.tab-list {
  width: 100%;
  display: flex;
  padding: 0.5rem;
  border: 1px solid var(--vip-color-stroke-subtle);
  border-radius: 999px;
  margin-bottom: 1rem;
  position: relative;

  .active-tab-indicator-container {
    position: absolute;
    width: 100%;
    height: 100%;
    inset: 0;
    padding: 0.5rem;
    border-radius: 999px;
    display: flex;
    align-items: center;
  }

  .tab {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0;
    border-radius: 999px;
    cursor: pointer;
    font: var(--vip-typography-body-sm-regular);
    color: var(--vip-color-themed-text-default);
    border: none;
    background-color: transparent;
    z-index: 2;
    position: relative;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &.active {
      font: var(--vip-typography-body-sm-healthy);
      border: none;
      outline: none;
    }

    &:focus {
      border: none;
    }

    .divider {
      position: absolute;
      height: 100%;
      width: 1px;
      background-color: var(--vip-color-stroke-subtle);
    }

    .after {
      right: 0;
    }

    .before {
      left: 0;
    }
  }
}

/* Transition for the tab panel */
.tabPanelEnter {
  transition:
    opacity 200ms,
    transform 200ms;
}

.tabPanelEnterFrom {
  opacity: 0;
  transform: translateY(-2rem);
}
.tabPanelEnterTo {
  opacity: 1;
  transform: translateY(0);
}
